import React, { useState, useEffect, useMemo } from "react";
import {
  Football,
  AppleFilled,
  FacebookFilled,
  PlayStoreFilled,
  ViberFilled,
  YoutubeFilled,
  TelegramFilled,
  Cancel,
} from "@assets";
import {
  Button,
  CloseContainer,
  Container,
  Description,
  DescriptionContainer,
  FollowTitle,
  FollowWrapper,
  Logo,
  Name,
  // RecaptchaContainer,
  RootContainer,
  TypeInfo,
  UserName,
  Welcome,
  Loader
} from "./ShareReceived.style";
import api from "@api/api";
import { useLocation, useNavigate, Navigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { PUBLIC_ROUTE } from '@router/route.constants';
import { useSelector } from "react-redux";
import { getFingerprintData, formatShareName } from "@utils";
import { Spin } from "antd";
// import ReCAPTCHA from 'react-google-recaptcha';

// A custom hook that builds on useLocation to parse
// the query string for you.
function useQuery() {
  const { search } = useLocation();

  return useMemo(() => new URLSearchParams(search), [search]);
}

const ShareReceived = () => {
  const { social_links } = useSelector((state) => state.app.settings);
  const [promoText, setPromoText] = useState('');
  const navigate = useNavigate();
  const query = useQuery();
  const isLoggedIn = useSelector((state) => state.auth.token);
  const { t } = useTranslation();
  let share_id = query.get('share_id');
  const [capToken, setCapToken] = useState('');
  const [loading, setLoading] = useState(true)
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [shareType, setShareType] = useState('');
  const [flag, setFlag] = useState(false);

  const Link = ({ url, children }) => (
    <a href={url} target="_blank" rel="noreferrer noopen">
      {children}
    </a>
  );

  useEffect(() => {
    if (!isLoggedIn && capToken) {
      getFingerprintData()
        .then(device_id => {
          viewShareLink(device_id);
        })
        .catch(() => { });
    }
    //eslint-disable-next-line
  }, [isLoggedIn, capToken]);


  useEffect(() => {
    let ele = document.getElementsByClassName('grecaptcha-badge')[0]?.style;
    if (ele) {
      ele.visibility = 'visible';
    }

    return () => {
      if (ele) { ele.visibility = 'hidden'; }
    };
  }, []);

  // useEffect(() => {
  //   flag && handleRecaptchaVerification();

  // }, [flag]);

  useEffect(() => {
    setTimeout(() => {
      setFlag(true);
    }, 500);

  }, []);


  // const handleRecaptchaVerification = async () => {
  //   const token = await window.grecaptcha.execute(`${process.env.REACT_APP_RECAPTCHA_KEY}`);
  //   setCapToken(token)
  // };

  const viewShareLink = (device_id) => {
    setLoading(true);
    api
      .viewShareLink({
        share_id,
        device_id,
        recaptcha_token: "pAAAKvTqUg6b6g-TZQFB9nLlxf",
      })
      .then(({ promoted_text, name, phone, type }) => {
        setLoading(false)
        setPromoText(promoted_text);
        setName(name);
        setPhone(phone);
        setShareType(type);
      })
      .catch(() => {
        setLoading(false)
        setPromoText(`${t('share.viewErrorMsg')}`)
      });
  }


  const goToRegister = () => {
    navigate(`/${PUBLIC_ROUTE.REGISTER}`)
  }

  const close = () => {
    navigate(`/${PUBLIC_ROUTE.HOME}`);
  }

  if (isLoggedIn) {
    return <Navigate to={`/${PUBLIC_ROUTE.HOME}`} />
  }

  return (
    <>
      <RootContainer>

        {loading && (
          <Loader>
            <Spin size="large" />
          </Loader>
        )}

        {!loading && (
          <>
            <CloseContainer>
              <Cancel onClick={close} />
            </CloseContainer>
            <Name>Ballone Gabar</Name>
            <Welcome>
              <Football />
              <span> {t("share.welcome")} </span>
              <Football />
            </Welcome>
            <Container>
              <Logo />
              <DescriptionContainer>
                <Description>
                  {name && shareType &&
                    <>
                      <UserName>
                        {t("share.fromOwner", {
                          name,
                          phone,
                        })}
                      </UserName>
                      <TypeInfo>{`Ballone Gabar Gaming ${formatShareName(shareType)}!`}</TypeInfo>
                    </>
                  }

                  {promoText.split(t("common.appName"))[0]}

                  {promoText.split(t("common.appName"))[1] && (
                    <>
                      <span>{` ${t("common.appName")} `}</span>
                      {promoText.split(t("common.appName"))[1]}
                    </>
                  )}
                </Description>
                <Button type="primary" onClick={goToRegister}>
                  {t("auth.register")}
                </Button>
              </DescriptionContainer>
            </Container>
            <FollowTitle>{t("home.appDownloadSubTitle2")}</FollowTitle>
            <FollowWrapper>
              <Link url={social_links?.app_store_link}>
                <AppleFilled id="app" />
              </Link>
              <Link url={social_links?.play_store_link}>
                <PlayStoreFilled id="app" />
              </Link>
            </FollowWrapper>
            <FollowTitle> {t("home.appDownloadSubTitle1")}</FollowTitle>
            <FollowWrapper>
              <Link url={social_links?.fb_link}>
                <FacebookFilled />
              </Link>
              <Link url={social_links?.viber_link}>
                <ViberFilled />
              </Link>
              <Link url={social_links?.telegram_link}>
                <TelegramFilled />
              </Link>
              <Link url={social_links?.youtube_link}>
                <YoutubeFilled />
              </Link>
            </FollowWrapper>
          </>
        )}

      </RootContainer>
    </>
  );
};

export default ShareReceived;
